export const texas = {
  "48000": "Texas",
  "48001": "Anderson County",
  "48003": "Andrews County",
  "48005": "Angelina County",
  "48007": "Aransas County",
  "48009": "Archer County",
  "48011": "Armstrong County",
  "48013": "Atascosa County",
  "48015": "Austin County",
  "48017": "Bailey County",
  "48019": "Bandera County",
  "48021": "Bastrop County",
  "48023": "Baylor County",
  "48025": "Bee County",
  "48027": "Bell County",
  "48029": "Bexar County",
  "48031": "Blanco County",
  "48033": "Borden County",
  "48035": "Bosque County",
  "48037": "Bowie County",
  "48039": "Brazoria County",
  "48041": "Brazos County",
  "48043": "Brewster County",
  "48045": "Briscoe County",
  "48047": "Brooks County",
  "48049": "Brown County",
  "48051": "Burleson County",
  "48053": "Burnet County",
  "48055": "Caldwell County",
  "48057": "Calhoun County",
  "48059": "Callahan County",
  "48061": "Cameron County",
  "48063": "Camp County",
  "48065": "Carson County",
  "48067": "Cass County",
  "48069": "Castro County",
  "48071": "Chambers County",
  "48073": "Cherokee County",
  "48075": "Childress County",
  "48077": "Clay County",
  "48079": "Cochran County",
  "48081": "Coke County",
  "48083": "Coleman County",
  "48085": "Collin County",
  "48087": "Collingsworth County",
  "48089": "Colorado County",
  "48091": "Comal County",
  "48093": "Comanche County",
  "48095": "Concho County",
  "48097": "Cooke County",
  "48099": "Coryell County",
  "48101": "Cottle County",
  "48103": "Crane County",
  "48105": "Crockett County",
  "48107": "Crosby County",
  "48109": "Culberson County",
  "48111": "Dallam County",
  "48113": "Dallas County",
  "48115": "Dawson County",
  "48117": "Deaf Smith County",
  "48119": "Delta County",
  "48121": "Denton County",
  "48123": "DeWitt County",
  "48125": "Dickens County",
  "48127": "Dimmit County",
  "48129": "Donley County",
  "48131": "Duval County",
  "48133": "Eastland County",
  "48135": "Ector County",
  "48137": "Edwards County",
  "48139": "Ellis County",
  "48141": "El Paso County",
  "48143": "Erath County",
  "48145": "Falls County",
  "48147": "Fannin County",
  "48149": "Fayette County",
  "48151": "Fisher County",
  "48153": "Floyd County",
  "48155": "Foard County",
  "48157": "Fort Bend County",
  "48159": "Franklin County",
  "48161": "Freestone County",
  "48163": "Frio County",
  "48165": "Gaines County",
  "48167": "Galveston County",
  "48169": "Garza County",
  "48171": "Gillespie County",
  "48173": "Glasscock County",
  "48175": "Goliad County",
  "48177": "Gonzales County",
  "48179": "Gray County",
  "48181": "Grayson County",
  "48183": "Gregg County",
  "48185": "Grimes County",
  "48187": "Guadalupe County",
  "48189": "Hale County",
  "48191": "Hall County",
  "48193": "Hamilton County",
  "48195": "Hansford County",
  "48197": "Hardeman County",
  "48199": "Hardin County",
  "48201": "Harris County",
  "48203": "Harrison County",
  "48205": "Hartley County",
  "48207": "Haskell County",
  "48209": "Hays County",
  "48211": "Hemphill County",
  "48213": "Henderson County",
  "48215": "Hidalgo County",
  "48217": "Hill County",
  "48219": "Hockley County",
  "48221": "Hood County",
  "48223": "Hopkins County",
  "48225": "Houston County",
  "48227": "Howard County",
  "48229": "Hudspeth County",
  "48231": "Hunt County",
  "48233": "Hutchinson County",
  "48235": "Irion County",
  "48237": "Jack County",
  "48239": "Jackson County",
  "48241": "Jasper County",
  "48243": "Jeff Davis County",
  "48245": "Jefferson County",
  "48247": "Jim Hogg County",
  "48249": "Jim Wells County",
  "48251": "Johnson County",
  "48253": "Jones County",
  "48255": "Karnes County",
  "48257": "Kaufman County",
  "48259": "Kendall County",
  "48261": "Kenedy County",
  "48263": "Kent County",
  "48265": "Kerr County",
  "48267": "Kimble County",
  "48269": "King County",
  "48271": "Kinney County",
  "48273": "Kleberg County",
  "48275": "Knox County",
  "48277": "Lamar County",
  "48279": "Lamb County",
  "48281": "Lampasas County",
  "48283": "La Salle County",
  "48285": "Lavaca County",
  "48287": "Lee County",
  "48289": "Leon County",
  "48291": "Liberty County",
  "48293": "Limestone County",
  "48295": "Lipscomb County",
  "48297": "Live Oak County",
  "48299": "Llano County",
  "48301": "Loving County",
  "48303": "Lubbock County",
  "48305": "Lynn County",
  "48307": "McCulloch County",
  "48309": "McLennan County",
  "48311": "McMullen County",
  "48313": "Madison County",
  "48315": "Marion County",
  "48317": "Martin County",
  "48319": "Mason County",
  "48321": "Matagorda County",
  "48323": "Maverick County",
  "48325": "Medina County",
  "48327": "Menard County",
  "48329": "Midland County",
  "48331": "Milam County",
  "48333": "Mills County",
  "48335": "Mitchell County",
  "48337": "Montague County",
  "48339": "Montgomery County",
  "48341": "Moore County",
  "48343": "Morris County",
  "48345": "Motley County",
  "48347": "Nacogdoches County",
  "48349": "Navarro County",
  "48351": "Newton County",
  "48353": "Nolan County",
  "48355": "Nueces County",
  "48357": "Ochiltree County",
  "48359": "Oldham County",
  "48361": "Orange County",
  "48363": "Palo Pinto County",
  "48365": "Panola County",
  "48367": "Parker County",
  "48369": "Parmer County",
  "48371": "Pecos County",
  "48373": "Polk County",
  "48375": "Potter County",
  "48377": "Presidio County",
  "48379": "Rains County",
  "48381": "Randall County",
  "48383": "Reagan County",
  "48385": "Real County",
  "48387": "Red River County",
  "48389": "Reeves County",
  "48391": "Refugio County",
  "48393": "Roberts County",
  "48395": "Robertson County",
  "48397": "Rockwall County",
  "48399": "Runnels County",
  "48401": "Rusk County",
  "48403": "Sabine County",
  "48405": "San Augustine County",
  "48407": "San Jacinto County",
  "48409": "San Patricio County",
  "48411": "San Saba County",
  "48413": "Schleicher County",
  "48415": "Scurry County",
  "48417": "Shackelford County",
  "48419": "Shelby County",
  "48421": "Sherman County",
  "48423": "Smith County",
  "48425": "Somervell County",
  "48427": "Starr County",
  "48429": "Stephens County",
  "48431": "Sterling County",
  "48433": "Stonewall County",
  "48435": "Sutton County",
  "48437": "Swisher County",
  "48439": "Tarrant County",
  "48441": "Taylor County",
  "48443": "Terrell County",
  "48445": "Terry County",
  "48447": "Throckmorton County",
  "48449": "Titus County",
  "48451": "Tom Green County",
  "48453": "Travis County",
  "48455": "Trinity County",
  "48457": "Tyler County",
  "48459": "Upshur County",
  "48461": "Upton County",
  "48463": "Uvalde County",
  "48465": "Val Verde County",
  "48467": "Van Zandt County",
  "48469": "Victoria County",
  "48471": "Walker County",
  "48473": "Waller County",
  "48475": "Ward County",
  "48477": "Washington County",
  "48479": "Webb County",
  "48481": "Wharton County",
  "48483": "Wheeler County",
  "48485": "Wichita County",
  "48487": "Wilbarger County",
  "48489": "Willacy County",
  "48491": "Williamson County",
  "48493": "Wilson County",
  "48495": "Winkler County",
  "48497": "Wise County",
  "48499": "Wood County",
  "48501": "Yoakum County",
  "48503": "Young County",
  "48505": "Zapata County",
  "48507": "Zavala County",
};
